import { Pressable, Text, View } from "react-native";
import { useSlot, useStyled } from "use-styled";
import { Avatar } from "./avatar";

const TabRoot = useStyled(Pressable, {
  base: {
    className: "flex-row items-center justify-between",
    accessibilityRole: "button",
    style: {},
  },
  variants: {
    size: {
      md: { className: "p-2 rounded-xl" },
    },
    intent: {
      active: { className: "bg-teachLoop-creamDark border border-teachLoop-creamDark" },
      inActive: { className: "border border-teachLoop-creamDark" }, 
    },
    close: {
      true: { className: "gap-2 flex-row" },
    },
  },
  defaultVariants: {
    size: "md",
  },
  compoundVariants: [],
});

const TabText = useStyled(Text, {
  base: {
    className: "font-geologica-regular font-normal text-gray-800 mx-2",
  },
  variants: {
    size: {
      md: { className: "text-base leading-6" },
    },
    intent: {
      active: { className: "font-geologica-medium font-medium" },
    },
  },
  defaultVariants: {
    size: "md",
  },
});

const TabDot = useStyled(View, {
  base: {
    className: "w-[9px] h-[9px] bg-teal-600 rounded-full items-center justify-center", 
  },
  variants: {},
  defaultVariants: {},
});

export const Tab = useSlot(TabRoot, {
  Text: TabText,
  Close: TabDot,
  Dot: TabDot,
  Avatar : Avatar
});
